export default {
  navigation: [
    { name: 'Inicio', href: '/' },
    { name: 'Servicios', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Acerca de', href: '/about' },
    { name: 'Contacto', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Suiza, cantones de Vaud y Ginebra',
    whatsapp: '+41772184502',
    workingHours: 'Lun-Vie: 7:00-17:00'
  }
};